import React from 'react'
import PropTypes from "prop-types"
import { size, keys } from 'lodash'
import moment from 'moment'

import { Modal, Glyphicon } from 'react-bootstrap'

import Button from '../components/Button'
import TripTasks from './TripTasks'

const dateString = date => {
  const ds = moment(date).diff(moment().startOf('day'), "days")
  if (ds < 0) return ` hace ${-1 * ds} días (${date})`
  else if (ds == 0) return `hoy`
  else if (ds == 1) return `mañana`
  else return ` en ${ds} días (${date})` // if (ds >= 2)
}

const renderTask = task => (
  <div key={task._id}>
    <label>
      <span>{task.user}</span>
      <span>, {task.dueDate ? `${dateString(task.dueDate)}` : "sin fecha"}</span>
    </label>
    <div style={{ paddingLeft: 10 }}>
      {task.text}
    </div>
  </div>
)

class TripTasksDisplay extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { modal: false }
  }

  render() {
    const shownTasksCount = size(this.props.nextTasksPerUser)
    return (
      <React.Fragment>
        <div
          style={{ position: "relative", minHeight: 65 }}
          onClick={() => this.setState({ modal: true })}
        >
          {
            keys(this.props.nextTasksPerUser)
              .map(user => {
                const task = this.props.nextTasksPerUser[user]
                if (!task) return JSON.stringify({ user, task })
                else return renderTask(task)
              })
          }

          {
            this.props.numberOfTasks > 1 && (
              <i>Hay {this.props.numberOfTasks - shownTasksCount} tareas más.</i>
            )
          }

          <Glyphicon
            glyph="pencil"
            style={{ position:"absolute", fontSize:"14", right:5, top:5, opacity:0.5 }}
          />
        </div>

        {
          this.state.modal && (
            <Modal show onHide={() => this.setState({ modal: false })}>
              <Modal.Header>
                <Modal.Title>
                  Tareas para {this.props.trip.realName || this.props.trip.name || <i>[Cliente sin nombre]</i>}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <TripTasks trip={this.props.trip} />
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ modal: false })} label="Cerrar" />
              </Modal.Footer>
            </Modal>
          )
        }
      </React.Fragment>
    )
  }
}

TripTasksDisplay.propTypes = {
  trip: PropTypes.object.isRequired,
  nextTasksPerUser: PropTypes.objectOf(PropTypes.object).isRequired, // { [string]: Object },
  numberOfTasks: PropTypes.number.isRequired,
}

export default TripTasksDisplay
